<template>
  <slot></slot>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: 'checkGroup',
  data() {
    return {
      formCheckArr: []
    }
  },
  provide() {
    return {
      reactiveData: this
    }
  },
  methods: {
    addForm: function (fun) {
      //添加事件处理,修复s-table滚动导致的重复添加校验列表问题
      if (this.formCheckArr.length === 0) {
        this.formCheckArr.push(fun);
      } else {
        let isHave = false;
        for (let i = 0; i < this.formCheckArr.length; i++) {
          if (this.formCheckArr[i].keys === fun.keys) {
            this.formCheckArr[i].func = fun.func
            isHave = true
          }
        }
        if(!isHave){
          this.formCheckArr.push(fun);
        }
      }
    },
    clearValidate: function () {
      this.formCheckArr.length = 0;
    },
    validate: function () {
      return  new Promise(resolve => {
        let promiseArr = [];
        if (Array.isArray(this.formCheckArr) && this.formCheckArr.length){
          this.formCheckArr.forEach(item => {
            promiseArr.push(item.func?.());
          })
          Promise.all([...promiseArr]).then(res => {
            if (res.includes(false)){
              resolve(false);
            }else {
              resolve(true);
              this.clearValidate();
            }
          })
        }else {
          resolve(true);
          this.clearValidate();
        }
      })
    }
  }
})
</script>

<style scoped>

</style>